/**
 * @Author: Anandp
 * @Date:   2024-04-17 18:40:50
 * @Last Modified by:   Anandp
 * @Last Modified time: 2024-12-23 16:42:13
 */
import React, { useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { ReactComponent as SmartLeaderLogo } from "../../icons/untitled-ui/smartLeaderWhite.svg";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { RouterLink } from "src/components/router-link";
import surveyAPIService from "src/services/surveyApi";
import { useUser } from "src/hooks/use-user";
import { useState } from "react";
import { createTypography } from "src/theme/base/customTypography";
import MyEmotionalResilienceSurveyTile from "./EmotionalResilienceComponents/surveyCards";
import loginApiService from "src/services/loginAPI";
import * as SldButtons from "src/theme/base/SldButtons";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import * as SldSurveyCard from "src/theme/base/SldSurveyCard";
import { useLocation } from "react-router";
import LinkExpired from "../wiredUpSurveys/surveys/linkExpire";



/**
 * Emotional resilienece survey start page component
 *@module EmotionalResilienceSurveyStartPage
 * @param {object} props - Component properties.
 * @returns {JSX.Element} The rendered component.
 */
function MyEmotionalResilienceStartPageLayout(props) {
  const { children } = props;
  // const id = 7;
  // eslint-disable-next-line
  const token = "tokenuser";
  // const sectionPage = 1;

  const accesssToken = sessionStorage.getItem("accessToken");
  // eslint-disable-next-line
  const user = useUser();
  const queryParameters = new URLSearchParams(window.location.search);
  const [inviteId, setInviteId] = useState(null);
  const [isLoading ,setIsLoading] = useState(true);
  const typography = createTypography()
  const [surveyId, setSurveyId] = useState(queryParameters.get("surveyId"));
  const location = useLocation();
  const [valid, setValid] = useState(0);
  /**
   * Function to get invite id , If no invite id is present new invite id will be created
   * @date 11/5/2023 - 12:07:16 AM
   *
   * @async
   * */
  const getInviteId = async () => {
    try {
      const inviteIdGetData = {
        survey_id: surveyId,
        inviteId: inviteId,
        timeStamp: "",
        teamId: "",
      };
      //api call to check invite id
      const response = await surveyAPIService.checkInviteId(
        inviteIdGetData,
        accesssToken
      );
      setInviteId(response.data.inviteId);
      setIsLoading(false);
    } catch (error) {}
  };
 useEffect(() => {
   const init = async () => {
     if (location.search.substring(1) && !queryParameters.get("surveyId")) {
       const base64String = location.search.substring(1);
 
       // Decode
       const decodedString = atob(base64String);
 
       // Split params
       const paramsArray = decodedString.split("&");
       const params = {};
 
       paramsArray.forEach((param) => {
         const equalSignIndex = param.indexOf("=");
         const key = param.slice(0, equalSignIndex);
         const value = param.slice(equalSignIndex + 1);
         params[key] = value;
       });
 
       // Set state
       console.log('params.inviteId',params.inviteId);
       
       
       // setEmailToken(params.token);
       setSurveyId(params.surveyId);
      //  setTenantId(params.tenantId);
 
       await loginApiService.setCookie(params.token);
       await validateToken();
       setInviteId(params.inviteId);
     } else {
       getInviteId();
     }
   };
 
   init();
 
   // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [location.search]);
  /**
 * Validates and decodes the email token to retrieve user details.
 * If valid, stores user details and access token in session storage.
 *
 * @async
 * @function validateToken
 * @returns {Promise<void>}
 */
  const validateToken = async () => {
    try {
      const response = await loginApiService.decodeToken('');
      if (response?.userId) {
        const stringifiedUser = JSON.stringify(response)
        sessionStorage.setItem("userDetails", stringifiedUser);
      }


    } catch (error) {
console.log(error);

    }
  }
    /**
 * Validates the survey invitation link using the provided email token and invite ID.
 * Updates the validation state based on the response.
 *
 * @async
 * @function validateLink
 * @returns {Promise<void>}
 */
    const validateLink = async () => {
      try {
        const response = await loginApiService.validateLink('', inviteId,12);
        if(response.length > 0){
          setValid((response[response.length - 1].active !== 0 && response[response.length - 1].is_complete === 0) ? 0 : 1);
        }
        setIsLoading(false)
      } catch (error) {
  console.log(error);
  
      }
    }
    useEffect(() => {
      if (inviteId) {
        validateLink();
      }
      // eslint-disable-next-line
    }, [inviteId])
  if (isLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  if (valid === 1) {
    return <LinkExpired />;
  }
  return (
    <SldSurveyCard.SurveyGrid
    container
    spacing={0}
   
  >
    <SldSurveyCard.SurveyGridItem
      item
      lg={12}
      sm={12}
    >
 <SldSurveyCard.SurveyLogo>
          <SmartLeaderLogo width='250' />
        </SldSurveyCard.SurveyLogo>
        <Stack
          justifyContent="space-between"
          alignItems="center"
          spacing={6}
        >
          <Typography sx={typography.qNheading}>
            My Emotional Resilience Questionnaire
          </Typography>
          <SldButtons.SurveyClock 
            variant="contained">
          <AccessTimeIcon />
            <Typography variant="subtitle1"> Duration <span>15 mins</span></Typography>
          </SldButtons.SurveyClock>
          {/* </Grid> */}

          
        </Stack>
      </SldSurveyCard.SurveyGridItem>
      <SldSurveyCard.SurveyStack
    spacing={3}
    
    sx={{
      marginTop:{lg :'-140px', sm :'5px', xs :'3px'},
      padding:{lg:'0 60px', md:'0 60px', sm:'0 0', xs:'0'},
    }}
  >
      <MyEmotionalResilienceSurveyTile />
      <SldSurveyCard.SurveyRules 
      lg={12} 
     >
        <SldSurveyCard.SurveyContainer>{children}</SldSurveyCard.SurveyContainer>

        <SldButtons.WhiteButtonCap endIcon={<ArrowForwardIcon />}
            variant="contained"
            
            component={RouterLink}
            to={`/surveyQuestions?id=${surveyId}&inviteId=${inviteId}`}
          >
            <Typography sx={typography.startButton}
variant="subtitle1">
              Start
            </Typography>
            </SldButtons.WhiteButtonCap>
      </SldSurveyCard.SurveyRules >

      </SldSurveyCard.SurveyStack>
      </SldSurveyCard.SurveyGrid>
  );
}

export default MyEmotionalResilienceStartPageLayout;
